import React from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { selectModalId } from "../../features/modal/state/modalSelectors";
import { closeModal } from "../../features/modal/state/modalSlice";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@material-ui/core";
import ErrorText from "../../app/components/ErrorText";
import ControlledInput from "../../app/components/inputs/ControlledInput";
import SpinnerButton from "../../app/components/buttons/SpinnerButton";
import { useUpdateServicePlanInterventionForm } from "../hooks/useUpdateServicePlanInterventionForm";

interface Props {
  goalId: string;
  interventionId: string;
}

export const updateServicePlanInterventionFormDialogId =
  "update-service-plan-intervention-dialog";

export const UpdateServicePlanInterventionFormDialog: React.FC<Props> = ({
  goalId,
  interventionId,
}) => {
  const selectedModalId = useAppSelector(selectModalId);
  const dispatch = useAppDispatch();

  const {
    state: { goal, updateInterventionRequestState },
    form: { isValid, clearForm, control },
    handlers: { handleSubmit },
  } = useUpdateServicePlanInterventionForm(goalId, interventionId);

  const { isLoading, error } = updateInterventionRequestState;

  const handleCloseModal = () => {
    clearForm();
    dispatch(closeModal());
  };

  return (
    <Dialog
      open={updateServicePlanInterventionFormDialogId === selectedModalId}
      maxWidth="sm"
      fullWidth
    >
      <form onSubmit={handleSubmit}>
        <DialogTitle>
          Update an Intervention
          <ErrorText error={error?.message} />
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography>Goal: {goal?.name}</Typography>
            </Grid>

            <Grid item md={12} xs={12}>
              <ControlledInput
                name="description"
                label="Description"
                type="text"
                control={control}
                disabled={isLoading}
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
                placeholder={"See Note Below"}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant={"body2"}>
                This Description should include the type of Intervention (e.g.,
                "mentorship"), frequency (e.g., "# per week for # weeks") and
                location (e.g., "at school").
              </Typography>
            </Grid>

            <Grid item md={12} xs={12}>
              <ControlledInput
                name="notes"
                label="Notes"
                control={control}
                disabled={isLoading}
                fullWidth
                multiline
                minRows={3}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <SpinnerButton
            content="Cancel"
            showSpinner={false}
            type="button"
            onClick={handleCloseModal}
            disabled={isLoading}
          />
          <SpinnerButton
            showSpinner={isLoading}
            content="Save"
            color="primary"
            type="submit"
            disabled={!isValid || isLoading}
          />
        </DialogActions>
      </form>
    </Dialog>
  );
};
